export default __webpack_public_path__ + "static/media/network.af823098.jfif";